var localAjaxErrorHandler = true;
$(function(){

    var hash = window.location.hash.substr(1);
    if (hash) {
        $('html,body').delay(500).animate({
            scrollTop: $("#"+hash).offset().top
        }, 1500);
    }

    // Add rel="noopener" to any links that need it
    $('a').each(function(i,a){
        var target = $(a).attr('target');
        
        if(target === '_blank') {
            $(a).attr('rel', 'noopener');
        }
    });

    // Mobile nav functions
    $('#main-nav>li>a').on('click', function(e){
        if(!isMobileNav() || $(this).hasClass('direct-link')){
            return true;
        }
        if(!$(this).next().hasClass('open') && $('#main-nav>li>a+ul').length){
            e.preventDefault();
            $('#main-nav>li>a+ul').removeClass('open');
            $('#main-nav>li>a+ul').hide(200);
            $(this).next().toggleClass('open');
            $(this).next().toggle(200);
        }
    });

    $("#map-click-image").on('click', MapClick.Click);

    $("#mbl-evt-filter").on('click', function(e){
        if(!isMobileNav()){
            return true;
        }
        e.preventDefault();
        $(this).toggleClass('open');
        $("#fltrs").toggle(200);
    });
    $("#mbl-evt-search").on('click', function(e){
        if(!isMobileNav()){
            return true;
        }
        e.preventDefault();
        $(this).toggleClass('open');
        $("#evt-srch").toggle(200);
    });


    // Set focus on skip link click
    $('.skip-link').on('click', function(){
        var skipTo = $("#"+this.href.split('#')[1]);
        skipTo.attr('tabindex', '0');
        skipTo.focus();
    });
    
	$('#mbl-menu-open,#mbl-menu-close').on('click', function(e){
		e.preventDefault();
		$('#mbl-menu').toggleClass('opened');
	});

	$('.fp-datepicker').fluffypicker({
		format: 'MM/DD/YYYY',
		minDateTime: function(){
			return moment( ).subtract( 1, "days" ); // Starting today
		},
		calendar: { saveOnDateSelect: true },
		showTime: false
	});

    // For birthdays
    $('.past-datepicker').fluffypicker({
		format: 'MM/DD/YYYY',
		maxDateTime: function(){
			return moment( ).subtract( 1, "days" ); // Starting today
		},
        initialDateTime: function(){
			return moment( ).subtract( 21, "years"  );
		},
		calendar: { saveOnDateSelect: true },
        useIcon: true,
        openOnFocus: false,
		showTime: false
	});
    
    // For recent past events
    $('.recent-past-datepicker').fluffypicker({
		format: 'MM/DD/YYYY',
		maxDateTime: function(){
			return moment( );
		},
        initialDateTime: function(){
			return moment( ); 
		},
		calendar: { saveOnDateSelect: true },
        useIcon: true,
        openOnFocus: false,
		showTime: false
	});
    
    $('.future-datepicker').fluffypicker({
		format: 'MM/DD/YYYY',
		minDateTime: function(){
			return moment( ); // Starting today
		},
		calendar: { saveOnDateSelect: true },
        useIcon: true,
        openOnFocus: false,
		showTime: false
	});
    
    $('#site-search form input, #site-search form button').on('focus', function(){
        document.getElementById('site-search').classList.add('focus');
    });
    $('#site-search form input, #site-search form button').on('blur', function(){
        document.getElementById('site-search').classList.remove('focus');
    });
    
    SiteMenu.Init($('#subsite-nav'));
});


function isMobileNav() {
    return $('#mbl-menu').is(':visible');
}

var MapClick = {
    loaded: false,
    segment: null,
    map: null,

    ApiLoaded: function(){
        var Settings = this.Settings();
        MapClick.map = new google.maps.Map(document.getElementById("map-canvas"),Settings);
        $("#map-click-image").fadeOut(250, MapClick.LoadMarker);
    },

    Click: function(){
        if(MapClick.loaded){
            return;
        }
        MapClick.loaded = true;
        MapClick.segment = $(this).data('segment');
        jQuery.ajax({
            url: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyB0S1OuqQxPFuXlKKHS_GS6BXsxWQSfv08&libraries=marker&callback=MapClick.ApiLoaded&loading=async',
            dataType: 'script',
            success: function(){
                // google.maps.event.addListenerOnce(map, 'idle', function(){
                //     // do something only the first time the map is loaded
                //     console.log(1)
                // });
            },
            async: true
        });
        if(typeof(dataLayer) !== 'undefined') {
            dataLayer.push({
                'event': 'Map Click Load',
                'map_click_status':'click'
            });
        }
    }, 

    LoadMarker: function(){
        var position= null;
        var icon= null;
        var mapname= null;
        switch(MapClick.segment){
            case 'stadium':
                position=new google.maps.LatLng(40.2903250,-76.6590250);
                icon='/hersheypark-stadium/assets/images/hps_pin.png';
                mapname= "Hershey Stadium Map"
                break;
            case 'giant-center':
                position=new google.maps.LatLng(40.286292,-76.669187);
                icon='/giant-center/assets/images/gc_pin.png';
                mapname= "Giant Center Map"
                break;
            case 'hershey-theatre':
                position=new google.maps.LatLng(40.285274,-76.648593);
                icon='/hershey-theatre/assets/images/ht_pin.png';
                mapname= "Hershey Theatre Map"
                break;
        }
        var marker = new google.maps.marker.AdvancedMarkerElement({
            map: MapClick.map,
            position: position,
            content: icon ? (() => {
                const img = document.createElement('img');
                img.src = icon;
				img.className = 'marker-drop';
                return img;
            })() : undefined
        });
        switch(MapClick.segment){
            case 'stadium':
                marker.addListener(marker, 'gmp-click', function() {
                    window.open( 'http://maps.google.com/maps?saddr=Current%20Location&daddr=Hersheypark+Stadium,Hershey,PA' , '_blank');
                });
                break;
            case 'giant-center':
                marker.addListener(marker, 'gmp-click', function() {
                    window.open( 'http://maps.google.com/maps?saddr=Current%20Location&daddr=Giant+Center,Hershey,PA' , '_blank');
                });
                break;
            case 'hershey-theatre':
                marker.addListener(marker, 'gmp-click', function() {
                    window.open( 'http://maps.google.com/maps?saddr=Current%20Location&daddr=Hershey+Theatre,Hershey,PA' , '_blank');
                });
                break;
            }
            google.maps.event.addListenerOnce(MapClick.map, 'tilesloaded', () => {
                document.getElementsByTagName('iframe')[0].title = mapname;
            });
    },

    Settings: function(){
        var center= null;
        switch(MapClick.segment){
            case 'stadium': 
                center=new google.maps.LatLng(40.2903789,-76.6590000);
                break;
            case 'giant-center': 
                center=new google.maps.LatLng(40.286472,-76.669157);
                break;
            case 'hershey-theatre': 
                center=new google.maps.LatLng(40.285319,-76.648589);
                break;
        }
        if (MapClick.segment=='hershey-theatre'){
            var styles= {
                center: center,
                zoom: 17,
						scrollwheel: false,
						mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [{
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#2C5880"
                    }, {
                        "visibility": "simplified"
                    }]
                }, {
                    "featureType": "landscape.natural",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#e8e3d7"
                    }, {
                        "saturation": 0
                    }, {
                        "lightness": 30
                    }, {
                        "visibility": "simplified"
                    }]
                }, {
                    "featureType": "landscape.man_made",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#e8e3d7"
                    }, {
                        "visibility": "simplified"
                    }]
                }, {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [{
                        "hue": "#8d191c"
                    }, {
                        "visibility": "off"
                    }]
                }, {
                    "featureType": "poi.attractions",
                    "elementType": "all",
                    "stylers": [{
                        "hue": "#5d543c"
                    }, {
                        "saturation": 0
                    }, {
                        "visibility": "simplifed"
                    }]
                }, {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [{
                        "hue": "#FFFFFF"
                    }, {
                        "saturation": -100
                    }, {
                        "lightness": 0
                    }, {
                        "visibility": "simplified"
                    }]
                }],
                mapId: 'YOUR_MAP_ID_HERE'
            };

        }
        else {var styles= {
                center: center,
                zoom: 16,
                scrollwheel: false,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                streetViewControl: false,
                zoomControlOptions: { position: google.maps.ControlPosition.LEFT_CENTER },
                panControlOptions: { position: google.maps.ControlPosition.LEFT_CENTER },
                styles: [{
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#2C5880"
                    }, {
                        "visibility": "simplified"
                    }]
                }, {
                    "featureType": "landscape.natural",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#d9e6d8"
                    }, {
                        "saturation": 0
                    }, {
                        "lightness": 30
                    }, {
                        "visibility": "simplified"
                    }]
                }, {
                    "featureType": "landscape.man_made",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#f1f0f0"
                    }, {
                        "visibility": "simplified"
                    }]
                }, {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [{
                        "hue": "#85171c"
                    }, {
                        "visibility": "off"
                    }]
                }, {
                    "featureType": "poi.sports_complex",
                    "elementType": "all",
                    "stylers": [{
                        "hue": "#0d4cbf"
                    }, {
                        "visibility": "simplifed"
                    }]
                }, {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [{
                        "hue": "#FFFFFF"
                    }, {
                        "saturation": -100
                    }, {
                        "lightness": 0
                    }, {
                        "visibility": "simplified"
                    }]
                }],
                mapId: 'YOUR_MAP_ID_HERE'
            };
        }
        return styles;
    }
    
}

/*
 * This is a near copy of the Menub class in the menubar.js file. It is here because of conflicts with
 * the two menus set up the same. This class is just for the site nav at the upper left corner.
 */
var SiteMenu = {
    menubar: null,
    topItems: null,
    topIndex: 0,
    hover: false,
    
    Init: function($menubar) {
        this.menubar = $menubar;
        this.topItems = $menubar.find('> li > a[role=menuitem]');
        
        $menubar.find('li').hoverIntent({
			over: function (e) {
                SiteMenu.hover = true;
				SiteMenu.DropDown.Show($(this).find('a[role=menuitem]').first());
			},
			out: function (e) {
				SiteMenu.DropDown.Hide($(this).find('a[role=menuitem]').first());
			},
            timeout: 300
		});
        
        $menubar.find('.dropdown-arrow').on('click', function(){
            if(!$(this).hasClass('open')) {
                SiteMenu.DropDown.Show($(this));
                return false;
            }
        });
        
        this.menubar.on('keydown', function(e){
            switch(e.keyCode) {
                case 32: // space bar
                    return SiteMenu.KeyControl.ActivateLink();
                case 13: // enter key
                    if($(e.target).data('enter-follow') == true) {
                        return true;
                    }
                    return SiteMenu.KeyControl.ActivateLink();
                case 27: // escape key
                    SiteMenu.Goto.Parent();
                    return false;
                case 37: // left arrow
                    SiteMenu.KeyControl.Arrow.Left();
                    return false;
                case 38: // up arrow
                    SiteMenu.KeyControl.Arrow.Up();
                    return false;
                case 39: // right arrow
                    SiteMenu.KeyControl.Arrow.Right();
                    return false;
                case 40: // down arrow
                    SiteMenu.KeyControl.Arrow.Down();
                    return false;
                case 36: // home key
                    SiteMenu.KeyControl.Home();
                    return false;
                case 35: // end key
                    SiteMenu.KeyControl.End();
                    return false;
                case 9: // tab key
                    return true;
            }

            if(e.keyCode >= 65 && e.keyCode <= 90) {
                // Character key pressed
                SiteMenu.Goto.NextLetter(String.fromCharCode(e.which));
                return false;
            }
        });
        
        $menubar.on('focusout', function(){
            // If not inside nav, close it
            setTimeout(function(){
                if(!SiteMenu.menubar.find(':focus').length) {
                    SiteMenu.DropDown.Clear();
                } 
            },150);
        });
    },
    
    Announce: function(message) {
        if($('#menu-announce').length) {
            $('#menu-announce').html(message);
        }
    },
    
    DropDown: {
        
        Show: function($menuitem) {
            if(!SiteMenu.HasSubmenu($menuitem)) {
                return;
            }
            
            // Close mobile menu if open
            if($('#mbl-menu').hasClass('opened')) {
                $('#mbl-menu-close').trigger('click');
            }
            
            
            var $submenu = $menuitem.siblings('[data-submenu="true"]');
            $submenu.addClass('open');
			$submenu.velocity('transition.fadeIn', {
                duration: 300,
                complete: function() {
                    // Set focus on first child
                    if(!SiteMenu.hover) {
                        $submenu.find('a[role="menuitem"]').first().focus();
                    }
                    else {
                        SiteMenu.hover = false;
                    }
                }
            });
            
            // Announce menu opening
            var $menuOpening = $menuitem.parent().find('ul[role=menu]');
            if($menuOpening.length && typeof($menuOpening.attr('aria-label')) !== 'undefined') {
                SiteMenu.Announce($menuOpening.attr('aria-label')+' Submenu Opened');
            }
            else {
                SiteMenu.Announce('Submenu Opened');
            }
            $menuitem.addClass('open');
            
            $('html').addClass('nav-opened');
            SiteMenu.menubar.trigger('menuOpen');
        },

        Hide: function($menuitem) {
            if(!SiteMenu.HasSubmenu($menuitem)) {
                return;
            }
            
            var $submenu = $menuitem.siblings('[data-submenu="true"]');
            $submenu.removeClass('open');
            $submenu.velocity('transition.fadeOut', {
                duration: 300,
                complete: function() {
                    
               }
            });
			$menuitem.removeClass('open');
            
            SiteMenu.menubar.trigger('menuClose');
            setTimeout(function(){
                if(!SiteMenu.topItems.hasClass('open')) {
                    $('html').removeClass('nav-opened');
                }
            },400);
        },
        
        /*
         * Close any open drop downs
         */
        Clear: function() {
            
            SiteMenu.menubar.find('a.open[role=menuitem]').each(function(i,menuitem){
                SiteMenu.DropDown.Hide($(menuitem));
            });
        }
    },
    
    Goto: {
        
        FirstTop: function() {
            SiteMenu.DropDown.Clear();
            SiteMenu.topItems.first().focus();
            SiteMenu.topIndex = 0;
        },

        LastTop: function() {
            SiteMenu.DropDown.Clear();  
            SiteMenu.topItems.last().focus();
            SiteMenu.topIndex = SiteMenu.topItems.length - 1;
        },
        
        PreviousTop: function() {
            var nextIndex = SiteMenu.topIndex - 1;
            if(nextIndex < 0) {
                nextIndex = SiteMenu.topItems.length - 1;
            }
            
            SiteMenu.DropDown.Clear();  
            SiteMenu.topItems.eq(nextIndex).focus();
            SiteMenu.topIndex = nextIndex;
        },
        
        NextTop: function() {
            var nextIndex = SiteMenu.topIndex + 1;
            if(nextIndex > (SiteMenu.topItems.length - 1) ) {
                nextIndex = 0;
            }
            if(!SiteMenu.menubar.find(':focus').length) {
                nextIndex = 0;
            }

            SiteMenu.DropDown.Clear();  
            SiteMenu.topItems.eq(nextIndex).focus();
            SiteMenu.topIndex = nextIndex;
        },
        
        /*
         * Close the drop down and change focus to the parent
         */
        Parent: function() {
            SiteMenu.topItems.eq(SiteMenu.topIndex).focus();
            SiteMenu.DropDown.Clear();
        },
        
        /*
         * Go to the next menuitem sibling that starts with the given letter
         * or do nothing.
         */
        NextLetter: function(letter) {
            var $ulParent = $(':focus').parents('ul').first();
            if(!$ulParent.length) {
                return;
            }

            // Cycle through menuitems, looking for next
            var $elements = $ulParent.find('> li > a');
            var focusIndex = 0;
            var matchingElements = [];
            $elements.each(function(i,a){
                if($(a).is(':focus') || $(a).parent().is(':focus')) {
                    focusIndex = i;
                }
                var aText = $.trim($(a).text());
                var firstLetter = aText.substr(0,1).toUpperCase();
                if(firstLetter == letter) {
                    matchingElements.push(i);
                }
            });
            if(!matchingElements.length) {
                return;
            }

            var matchFound = false;
            var leastMatch = 999;
            $.each(matchingElements, function(i,e){
                if(e > focusIndex) {
                    matchFound = true;
                    $elements.eq(e).focus();
                    if($ulParent.attr('role') === 'menubar') {
                        NavKeys.currentIndex = e;
                    }
                    return false;
                }
                if(e < leastMatch) {
                    leastMatch = e;
                }
            });

            if(!matchFound && leastMatch < $elements.length) {
                $elements.eq(leastMatch).focus();
                if($ulParent.attr('role') === 'menubar') {
                    NavKeys.currentIndex = leastMatch;
                }
            }
        }
    },
    
    /*
     * The object belows handles the keyboard navigation while within the main nav
     * per ADA guidelines: 
     * https://www.w3.org/TR/wai-aria-practices-1.1/examples/menubar/menubar-1/menubar-1.html
     * 
    SiteMenuar Behavior
        Space or Enter 	
            Open or Close popup menu (e.g. toggle). (Note, opening moves focus to first element, so closing isn't necessary)

        Left Arrow 	
            Moves focus to previous menubar menu item.
            If focus on first menubar menu item, focus is moved to last menubar menu item.

        Right Arrow 	
            Moves focus to next menubar menu item.
            If focus on last menubar menu item, focus is moved to first menubar menu item.

        Down Arrow 	
            Open popup menu.
            Moves focus to first popup menu item.

        Up Arrow 	
            Open popup menu.
            Moves focus to last popup menu item.

        Home 	
            Moves focus to first menubar menu item.

        End 	
            Moves focus to last menubar menu item.

        Character       
            Moves focus to next menubar item that starts with that letter.
            If no menubar menu item starts with the letter, focus does not move.

    ******
    Popup Menu Behavior
        Space or Enter 	
            Follow link.

        Escape 	
            Closes popup menu.
            Moves focus to current menubar menu item.

        Left Arrow 	
            Closes popup menu.
            Moves focus to previous menubar menu item.
            Open the popup menu of the previous menubar menuitem with focus.

        Right Arrow 
            Closes popup menu.
            Moves focus to next menubar menu item.
            Open the popup menu of the next menubar menuitem with focus.

        Up Arrow 	
            Moves focus to previous popup menu item.
            If first popup menu item, focus is moved to the last popup menu item.

        Down Arrow 	
            Moves focus to next popup menu item.
            If last popup menu item, focus is moved to the first popup menu item.

        Home 	
            Moves focus to first popup menu item.

        End 	
            Moves focus to last popup menu item.

        Character 	
            Moves focus to the next popup item that starts with that letter.
            If no popup menu item starts with the letter, focus does not move.

     */
    KeyControl: {
        
        Arrow: {
            
            Left: function() {
                // Are we in a submenu?
                var $ulParent = $(':focus').parents('ul').first();
                if(!$ulParent.length || $ulParent.attr('role') !== 'menu') {
                    SiteMenu.Goto.PreviousTop();
                    return;
                }

                /*
                 * We are in a submenu.
                 * If this is a nested submenu, return focus to the parent submenu.
                 * Otherwise, move to previous top.
                 */
                if($ulParent.parents('ul[role=menu]').length) {
                    // It is nested
                    var $parentA = $ulParent.parents('[data-submenu=true]').first().siblings('a');
                    SiteMenu.DropDown.Hide($parentA);
                    $parentA.focus();
                    return;
                }
                
                SiteMenu.Goto.PreviousTop();
            },
            
            Right: function() {
                // Are we in a submenu?
                var $ulParent = $(':focus').parents('ul').first();
                if(!$ulParent.length || $ulParent.attr('role') !== 'menu') {
                    SiteMenu.Goto.NextTop();
                    return;
                }
                
                /*
                 * We are in a submenu.
                 * If this menuitem has a nested submenu, open and focus that
                 * Otherwise, trigger next top.
                 */
                var $a = $(':focus');
                if(SiteMenu.HasSubmenu($a)) {
                    SiteMenu.DropDown.Show($a);
                    return;
                }
                
                SiteMenu.Goto.NextTop();
            },
            
            Up: function() {
                // Are we in a submenu?
                var $ulParent = $(':focus').parents('ul').first();
                if(!$ulParent.length || $ulParent.attr('role') !== 'menu') {
                    // No, trigger left behavior
                    SiteMenu.Goto.PreviousTop();
                    return;
                }
                
                // Move up the current submenu
                var currentIndex = 0;
                var numLis = 0;
                $ulParent.find('> li > a').each(function(i,li){
                    if($(li).is(':focus')) {
                        currentIndex = i;
                    }
                    numLis++;
                });
                
                var nextIndex = currentIndex - 1;
                if(nextIndex < 0) {
                    nextIndex = numLis - 1;
                }
                $ulParent.find('> li > a').eq(nextIndex).focus();
            },
            
            Down: function() {
                // Are we in a submenu?
                var $ulParent = $(':focus').parents('ul').first();
                if(!$ulParent.length || $ulParent.attr('role') !== 'menu') {
                    // Open current submenu
                    SiteMenu.DropDown.Show(SiteMenu.topItems.eq(SiteMenu.topIndex));
                    return;
                }
                
                // Move up the current submenu
                var currentIndex = 0;
                var numLis = 0;
                $ulParent.find('> li > a').each(function(i,li){
                    if($(li).is(':focus')) {
                        currentIndex = i;
                    }
                    numLis++;
                });
                
                var nextIndex = currentIndex + 1;
                if(nextIndex >= numLis ) {
                    nextIndex = 0;
                }
                $ulParent.find('> li > a').eq(nextIndex).focus();
            }
        },
        
        /*
         * This function is typically called by an [Enter] or [Space] key.
         * If the item has a submenu, it will open that. Otherwise it will
         * allow the link to be followed.
         * 
         * The return value can seem backwards. A return of true means there
         * is no submenu and the link can be followed. A return of false means
         * a submenu was opened and no further action should be taken.
         */
        ActivateLink: function() {
            var $a = $('a:focus');
            
            if(!$a.length) {
                return true;
            }
            
            if(SiteMenu.HasSubmenu($a)) {
                SiteMenu.DropDown.Show($a);
                return false;
            }
            
            return true;
        },
        
        End: function() {
            // Are we on a menu or top menubar?
            var $ulParent = $(':focus').parents('ul').first();
            if(!$ulParent.length || $ulParent.attr('role') !== 'menu') {
                // trigger menubar home
                SiteMenu.Goto.LastTop();
                return;
            }

            // Go to first submenu item
            $ulParent.find('> li > a').last().focus();
        },
        
        Home: function() {
            // Are we on a menu or top menubar?
            var $ulParent = $(':focus').parents('ul').first();
            if(!$ulParent.length || $ulParent.attr('role') !== 'menu') {
                // trigger menubar home
                SiteMenu.Goto.FirstTop();
                return;
            }

            // Go to first submenu item
            $ulParent.find('> li > a').first().focus();
        }
    },
    
    /*
     * Determine whether the given <a> tag has a submenu associated.
     */
    HasSubmenu: function($a) {
        return $a.siblings('[data-submenu="true"]').length;
    }
};


window.MapClick = MapClick;